<template>
  <div class="about-page">
    <div class="img-contact-header">
      <p class="aboutss need" style="font-size: 30px;">Contact Us</p>

      <p class="aboutss">
        Feel free to contact us for customer support or business solutions
      </p>
    </div>

    <div class="contacts">
      <form
        id="contact"
        action="mailto:info@xrubiconsolutions.com"
        method="post"
        enctype="text/plain"
      >
        <div
          style="display:flex; flex-direction: row; justify-content: space-between"
        >
          <label for="name"> Business Name </label
          ><input
            id="name"
            placeholder="Your name"
            type="text"
            name="name"
            tabindex="1"
            required
            autofocus
          />
        </div>
        <div
          style="display:flex; flex-direction: row; justify-content: space-between;"
        >
          <label for="name"> Email </label
          ><input
            id="email"
            placeholder="Email Address"
            type="text"
            name="email"
            tabindex="1"
            required
            autofocus
          />
        </div>
        <div
          style="display:flex; flex-direction: row; justify-content: space-between; align-items: space-between"
        >
          <label for="name"> Phone Number </label
          ><input
            id="phone number"
            placeholder="Phone Number"
            type="text"
            name="phone"
            tabindex="1"
            required
            autofocus
          />
        </div>
        <div
          style="display:flex; flex-direction: row; justify-content: space-between; align-items: space-between"
        >
          <label for="name"> Message </label>
          <textarea
            placeholder="Type your message here...."
            tabindex="5"
            name="message"
            required
          ></textarea>
        </div>

        <div class="consent">
          <input
            type="submit"
            value="Submit"
            class="btn btn-new btn-xl js-scroll-trigger"
            style="background-color: #A31B1F ; color : #FFFFFF; text-align: center ; width : 130px"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<style>
.about-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.about-contact {
  display: flex;
  font: normal normal normal 24px/35px Prompt;
  font: normal normal normal 16px/35px Prompt;
  font-weight: bold;
  width: 50vw;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
#para {
  color: #2d2d2d;
}

.consent {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.brand-area {
  display: flex;
  justify-content: center;
}
.img-contact-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px;
  justify-content: center;
  align-items: center;
  height: 800px;
  background-attachment: fixed;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("../assets/img/Contact.png");
  background-size: cover;
}

.mission {
  width: 450px;
  padding: 15px;
  color: #2d2d2d;
  font-size: 16px;
  height: 200px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #0000000d;
  border-radius: 15px;
  opacity: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.business {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  padding: 70px;
  color: #2d2d2d;
  font-size: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #0000000d;
  border-radius: 15px;
  opacity: 1;
  height: 185px;
  text-align: center;
}

.touch {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  width: 90vw;
  color: #2d2d2d;
  font-size: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #0000000d;
  border-radius: 15px;
  opacity: 1;
  height: 185px;
  text-align: center;
}

footer {
  width: 100vw;
}
body {
  background: black;
}

.form-info {
  color: #000;
  text-align: center;
  margin-top: 15px;
}

.contacts {
  position: relative;
  margin-top: -300px;
  margin-bottom: 40px;
  padding: 45px;
  width: 80vw;
  height: 85vh;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 7px 24px #00000014;
  border-radius: 10px;
  opacity: 1;
}

@import url(
  https://fonts.googleapis.com/css?family=Roboto:400,
  300,
  600,
  400italic
);

#contact input[type="text"],
#contact input[type="email"],
#contact input[type="tel"],
#contact input[type="url"],
#contact textarea,
#contact button[type="submit"] {
  font: 400 12px/16px "Roboto", Helvetica, Arial, sans-serif;
}

#contact {
  padding: 10px;
}

#contact input[type="text"],
#contact input[type="email"],
#contact input[type="tel"],
#contact input[type="url"],
#contact textarea {
  width: 85%;
  float: right;
  border: 1px solid #ccc;
  background: #fff;
  margin: 0 0 30px;
  padding: 10px;
}

#contact input[type="text"]:hover,
#contact input[type="email"]:hover,
#contact input[type="tel"]:hover,
#contact input[type="url"]:hover,
#contact textarea:hover {
  -webkit-transition: border-color 0.3s ease-in-out;
  -moz-transition: border-color 0.3s ease-in-out;
  transition: border-color 0.3s ease-in-out;
  border: 1px solid #aaa;
}

#contact textarea {
  height: 100px;
  max-width: 100%;
  resize: none;
}

#contact button[type="submit"] {
  cursor: pointer;
  width: 100%;
  border: none;
  color: #fff;
  margin: 0 0 5px;
  padding: 10px;
  font-size: 15px;
}

input {
  width: 250px;
}

#contact input:focus,
#contact textarea:focus {
  outline: 0;
  border: 1px solid #aaa;
}

::-webkit-input-placeholder {
  color: #888;
}

:-moz-placeholder {
  color: #888;
}

::-moz-placeholder {
  color: #888;
}

:-ms-input-placeholder {
  color: #888;
}

label {
  font-size: 12px;
  float: left;
  margin-right: 20px;
  color: #000;
}
</style>

<script>
import router from "../router";

export default {
  name: "Contact",
  methods: {
    navigate() {
      router.push({ name: "Contact" });
    },
  },
};
</script>
